import { render, staticRenderFns } from "./FrzCtnPalletSamplingNew.vue?vue&type=template&id=85a5a816"
import script from "./FrzCtnPalletSamplingNew.vue?vue&type=script&lang=js"
export * from "./FrzCtnPalletSamplingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports